import GET from '../GET'
import config from "../config.json"
let get = new GET('address');

export const address = {
  getOne(id){
    return get.one(id);
  },
  getFilterAddressList(limit = null){
    return fetch(`${config.apiUrl}/addresses/` +
      `${limit !== null ? `&limit=${limit}` : ``}` +
      `?display=[id,id_customer,alias,company,lastname,firstname,city,address1,phone,vat_number,postcode]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.addresses;
      })
  },
  async addAddress(data){
    const fe = await fetch(`${config.postRequest.url}addAddress.php?` +
      `${data.get("id")=== null ? `` : `id=${data.get("id")}&`}` +
      `id_customer=${data.get("id_customer")}` +
      `&alias=${data.get("alias")}` +
      `&company=${data.get("company")}` +
      `&lastname=${data.get("lastname")}` +
      `&firstname=${data.get("firstname")}`+
      `&city=${data.get("city")}`+
      `&addresse=${data.get("addresse")}`+
      `&phone=${data.get("phone")}`+
      `&vat_number=${data.get("vat_number")}`+
      `&postcode=${data.get("postcode")}`);

     if (!fe.ok) {
      throw new Error('erreur backend');
    }
   return await fe.json();
  }
}


// WEBPACK FOOTER //
// ./src/utils/address/index.js